import { Card } from "../components/Card.js";

export function ProductList() {
  return (
    <>
      <div>
        <Card />
      </div>
    </>
  );
}
